import React, { useEffect, useState } from "react";
import "../../styles/login.css";
import loginImg from "../../assets/globalImgs/auth-banner.png";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/authprovider";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import useHandleErrors from '../../utils/user.utils';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const Login = () => {
  const { fetchToken } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleErrors = useHandleErrors();
  const [showSatisfactionPopup, setShowSatisfactionPopup] = useState(false);
  const [empId, setEmpId] = useState(false);

  const handleLogin = async () => {
    if (!email) {
      toast.error("Email is required", { position: toast.POSITION.TOP_CENTER });
      return;
    }
    if (!password) {
      toast.error("Password is required", { position: toast.POSITION.TOP_CENTER });
      return;
    }

    setLoading(true);
    try {
      console.log("rememberMe", rememberMe);
      if (rememberMe) {
        localStorage.setItem("rememberedEmail", email);
        localStorage.setItem("rememberedPassword", password);
        localStorage.setItem("loginTime", Date.now().toString());
      } else {
        localStorage.removeItem("rememberedEmail");
        localStorage.removeItem("rememberedPassword");
      }

      const token = await fetchToken();
      console.log("token", token.token);

      const path = "/loginDetails";
      const URL = process.env.REACT_APP_BE_URL + path;
      const payload = { OfficialEmail: email, Password: password };
      const config = { headers: { Authorization: `Bearer ${token.token}` } };

      const response = await axios.post(URL, payload, config);
      console.log("response", response.data);

      if (response.status === 200) {
        const userDetails = response.data;
        localStorage.setItem("userDetails", JSON.stringify(userDetails));

        const showPopup = await fetchEmployeeSatisfactionDetails(userDetails.EmployeeId);
        setEmpId(userDetails.EmployeeId);

        if (showPopup) {
          setShowSatisfactionPopup(true);
        } else {
          window.location.href = "/home";
        }
      } else {
        handleErrors(response);
      }
    } catch (error) {
      if (error.response) {
        handleErrors(error.response);
      } else {
        toast.error("An error occurred during login. Please try again later.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedEmail = localStorage.getItem('rememberedEmail');
    const storedPassword = localStorage.getItem('rememberedPassword');
    console.log("storedEmail", storedEmail);
    if (storedEmail && storedPassword) {
      setEmail(storedEmail);
      setPassword(storedPassword);
      setRememberMe(true);
    }
  }, []);

  useEffect(() => {
    const preloading = document.getElementById("preloading");
    setTimeout(() => {
      if (preloading) {
        preloading.style.display = "none";
      }
    }, 400);
  }, []);

  const fetchEmployeeSatisfactionDetails = async (employeeId) => {
    try {
      const token = await fetchToken();
      const esatDetailsURL = `${process.env.REACT_APP_BE_URL}/employeeSatisfactionDetails?employeeId=${employeeId}`;

      const config = { headers: { Authorization: `Bearer ${token.token}` } };
      const response = await axios.get(esatDetailsURL, config);
      console.log("API Response:", response.data.empSatisfactions);

      if (response.data?.empSatisfactions && Array.isArray(response.data?.empSatisfactions)) {
        const today = new Date().toISOString().split("T")[0];
        const hasTodayRecord = response.data.empSatisfactions.some(
          (entry) => entry.satCreatedDate.split("T")[0] === today
        );

        console.log("hasTodayRecord", hasTodayRecord);
        return !hasTodayRecord;
      }
    } catch (error) {
      console.error("Error fetching satisfaction details:", error);
    }
    return true;
  };

  const handleSatisfaction = async (message, comments = "N/A") => {
    try {
      const token = await fetchToken();
      const esatURL = process.env.REACT_APP_BE_URL + "/employeeSatisfaction";
      const payload = {
        EmployeeId: empId,
        Message: message,
        Comments: comments,
        SatCreatedDate: new Date().toISOString().split("T")[0],
      };
      const config = { headers: { Authorization: `Bearer ${token.token}` } };
      await axios.post(esatURL, payload, config);
      toast.success("Thanks for sharing how you're feeling today!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } catch (error) {
      console.error("Error submitting satisfaction:", error);
      toast.error("Failed to submit satisfaction response.", { position: toast.POSITION.TOP_CENTER });
    } finally {
      setShowSatisfactionPopup(false);
      window.location.href = "/home";
    }
  };

  return (
    <div>
      {loading && (
        <div id="preloading">
          <span className="loader"></span>
        </div>
      )}
      <div className="wrapper">
        <section className="login-content">
          <div className="container">
            <div className="row align-items-center justify-content-center height-self-center">
              <div className="col-lg-8">
                <div className="card auth-card">
                  <div className="card-body p-0">
                    <div className="d-flex align-items-center auth-content">
                      <div className="col-lg-6 content-right text-center">
                        <img
                          src={loginImg}
                          className="img-fluid signin-banner"
                          alt="Signin Banner"
                        />
                      </div>
                      <div className="col-lg-6 align-self-center">
                        <div className="p-3">
                          <h3 className="mb-2">Sign In</h3>
                          <p>Login to stay connected.</p>
                          <div>
                            <div>
                              <div className="row">
                                <div className="col-lg-12" style={{ marginBottom: "0.75rem" }}>
                                  <div className="floating-label form-group">
                                    <input
                                      className="floating-input form-control"
                                      type="email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      placeholder=" "
                                      required
                                    />
                                    <label>Email</label>
                                  </div>
                                </div>
                                <div className="col-lg-12" style={{ marginBottom: "0.75rem" }}>
                                  <div className="floating-label form-group">
                                    <input
                                      className="floating-input form-control with-icon"
                                      type={showPassword ? "text" : "password"}
                                      value={password}
                                      onChange={(e) => setPassword(e.target.value)}
                                      placeholder=" "
                                      required
                                    />
                                    <label>Password</label>
                                    <span
                                      className="password-toggle-icon"
                                      onClick={() => setShowPassword(!showPassword)}
                                    >
                                      {showPassword ? <FaEyeSlash color="#004f7c" /> : <FaEye color="#004f7c" />}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="custom-control custom-checkbox mb-3">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      id="customCheck1"
                                      checked={rememberMe}
                                      onChange={(e) => setRememberMe(e.target.checked)}
                                    />
                                    <label
                                      className="custom-control-label control-label-1"
                                      htmlFor="customCheck1"
                                    >
                                      Remember Me
                                    </label>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <Link to="/forgotpassword" className="float-right mb-lg-0 mb-3">
                                    Forgot Password?
                                  </Link>
                                </div>
                              </div>
                            </div>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={handleLogin}
                            >
                              Sign In
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {showSatisfactionPopup && (
        <div className="satisfaction-popup">
          <div className="popup-content">
            <h4>How’s your day going so far?</h4>
            <div className="emoji-options">
              <button onClick={() => handleSatisfaction("Good")} className="emoji-button">
                😊 Good
              </button>
              <button onClick={() => handleSatisfaction("Bad")} className="emoji-button">
                😟 Bad
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default Login;